export default {"src":"/_next/static/media/GuideIconRed.b81996f9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};